import {
    Box,
    Flex,
    Paper,
    ScrollArea,
    Skeleton,
    Text,
    useMantineTheme,
} from "@mantine/core";
import { useElementSize } from "@mantine/hooks";
import { ResponsiveCalendar, ResponsiveTimeRange } from "@nivo/calendar";
import { useEffect } from "react";
import { dataHeatMapCalendarChart } from "../common/commonfunc";
import { nivotheme } from "../nivoChartTheme";

const AnalyticsCalendarHeatmapChart = ({ data }) => {
    const theme = useMantineTheme();
    const { ref, width, height } = useElementSize();
    useEffect(() => {}, [width, height]);

    console.log({ calendar: data });

    const getColor = (light, dark) => {
        return theme.colorScheme == "dark" ? dark : light;
    };
    // data = null;
    const greenColors = [
        theme.colors.green[5],
        theme.colors.green[6],
        theme.colors.green[7],
        theme.colors.green[8],
        theme.colors.green[9],
    ];

    return (
        <Paper withBorder p={"xs"} m={"xs"} ref={ref}>
            {!!!data && <Skeleton h={240} w={"100%"} />}
            {!!data && (
                <Box>
                    <Text ta={"center"} fw={"bold"} fz={"xl"}>
                        Test Taking Frequency
                    </Text>
                    <Box>
                        <ScrollArea style={{ width, height: 210 }}>
                            <Box sx={{ height: 200, width: 1000 }}>
                                <ResponsiveTimeRange
                                    data={data}
                                    from="2023-01-01"
                                    to={new Date().toISOString().split("T")[0]}
                                    emptyColor={getColor(
                                        theme.colors.gray[3],
                                        theme.colors.dark[3]
                                    )}
                                    dayBorderColor={getColor(
                                        theme.white,
                                        theme.colors.dark[7]
                                    )}
                                    monthBorderColor={getColor(
                                        theme.white,
                                        theme.colors.dark[7]
                                    )}
                                    colors={greenColors}
                                    margin={{
                                        top: 40,
                                        right: 40,
                                        bottom: 0,
                                        left: 40,
                                    }}
                                    // monthLegend={""}
                                    monthLegendOffset={5}
                                    monthLegendPosition={"before"}
                                    theme={nivotheme(theme)}
                                    align={"center"}
                                    square={true}
                                    dayRadius={20}
                                    daySpacing={4}
                                    // tooltip={({ data: { day, value } }) => {
                                    //     return (
                                    //         <Paper
                                    //             p={"xs"}
                                    //             withBorder
                                    //             shadow={"xl"}
                                    //             zIndex={5}
                                    //         >
                                    //             Date: {day}
                                    //             <br /> Tests taken: {value}
                                    //         </Paper>
                                    //     );
                                    // }}
                                    legends={[
                                        {
                                            anchor: "top-left",
                                            direction: "row",
                                            translateY: -25,
                                            itemCount: 2,
                                            itemWidth: 42,
                                            itemHeight: 0,
                                            itemsSpacing: 14,
                                            itemDirection: "left-to-right",
                                            symbolSize: 10,
                                            symbolShape: "circle",
                                        },
                                    ]}
                                />
                            </Box>
                        </ScrollArea>
                    </Box>
                </Box>
            )}
        </Paper>
    );
};

export default AnalyticsCalendarHeatmapChart;
